export default "__VITE_ASSET__CWvfY7zm__"